<div class="gallery">
  <div
    class="card"
    *ngFor="let asset of assets"
    (click)="toggleSelection(asset, $event)"
    [class.selected]="isSelected(asset)"
  >
    <div class="card-img">
      <img
        vdrLazyLoadImage
        class="asset-thumb"
        [lazySrc]="asset | assetPreview: 'thumb'"
        alt="{{ asset.name }}"
      />
    </div>
    <div class="detail">
      <!-- <vdr-entity-info
        [entity]="asset"
        [small]="true"
        (click)="entityInfoClick($event)"
      ></vdr-entity-info> -->
      <span class="truncate" [title]="asset.name">{{ asset.name }}</span>
    </div>
  </div>
</div>
<div class="info-bar">
  <div class="shadow-lg rounded-b pb-2">
    <div class="card-img">
      <div class="placeholder" *ngIf="selectionManager.selection.length === 0">
        <clr-icon shape="image" size="128"></clr-icon>
        <div>Không có lựa chọn</div>
      </div>
      <div
        *ngIf="isPreviewLoading && selectionManager.selection.length >= 1"
        class="loading-overlay"
      >
        <clr-spinner></clr-spinner>
      </div>
      <img
        class="preview"
        *ngIf="selectionManager.selection.length >= 1"
        [src]="activeAsset.preview + '?preset=medium'"
        (load)="onPreviewImageLoad()"
        (error)="onPreviewImageLoad()"
        [style.display]="isPreviewLoading ? 'none' : 'block'"
      />
    </div>
    <div
      class="card-block details grid gap-2"
      *ngIf="selectionManager.selection.length >= 1"
    >
      <div class="name">{{ activeAsset.name }}</div>
      <div>
        Kích thước:
        {{ activeAsset.fileSize | filesize }}
      </div>

      <!-- <ng-container *ngIf="selectionManager.selection.length === 1">
        <vdr-chip
          *ngFor="let tag of activeAsset.tags"
          [colorFrom]="tag.value"
          ><clr-icon shape="tag" class="mr2"></clr-icon>
          {{ tag.value }}</vdr-chip
        >
      </ng-container>
      <div *ngIf="selectionManager.selection.length === 1">
        <a
          [routerLink]="['/catalog/assets/', activeAsset.id]"
          (click)="editAssetClick.emit()"
          class="button-ghost"
        >
          <clr-icon shape="pencil"></clr-icon> {{ 'common.edit' | translate }}
          <clr-icon shape="arrow right"></clr-icon>
        </a>
      </div> -->
      <div *ngIf="selectionManager.selection.length === 1">
        <button (click)="previewAsset(activeAsset)" class="button-small mt-1">
          <clr-icon shape="eye"></clr-icon> Xem
        </button>
      </div>
      <div *ngIf="canDelete">
        <!-- Single Delete -->
        <button
          *ngIf="selectionManager.selection.length === 1"
          (click)="deleteAssets.emit([activeAsset])"
          class="button-small mt-1"
        >
          <clr-icon shape="trash" class="is-danger"></clr-icon>
          Xóa
        </button>
        <!-- Bulk Delete -->
        <button
          *ngIf="selectionManager.selection.length > 1"
          (click)="deleteAssets.emit(selectionManager.selection)"
          class="button-small mt-1"
        >
          <clr-icon shape="trash" class="is-danger"></clr-icon>
          Xóa {{ selectionManager.selection.length }} ảnh
        </button>
      </div>
      <!-- <div class="mt-1" *ngIf="selectionManager.selection.length === 1">
        <vdr-asset-preview-links
          class=""
          [asset]="lastSelected()"
        ></vdr-asset-preview-links>
      </div> -->
    </div>
  </div>
  <div
    class="card stack"
    [class.visible]="selectionManager.selection.length > 1"
  ></div>
  <div
    class="selection-count"
    [class.visible]="selectionManager.selection.length > 1"
  >
    {{
      'asset.assets-selected-count'
        | translate: { count: selectionManager.selection.length }
    }}
    <ul>
      <li
        *ngFor="let asset of selectionManager.selection"
        (click)="selectAssetInList(asset)"
      >
        <span class="truncate">{{ asset.name }}</span>
        <button
          class="deselect-btn"
          (click)="deselectAsset(asset, $event)"
          title="Bỏ chọn"
        >
          <clr-icon shape="times" size="12"></clr-icon>
        </button>
      </li>
    </ul>
  </div>
</div>
